import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {urlService} from 'vue3-starter/src/typescript/http/UrlService';
import {CategoryResult} from '@/brief-hub/deposit/freelancer/CategoryResult';
import {FamilyResult} from '@/brief-hub/deposit/freelancer/FamilyResult';
import * as RawModel from '@/common/api/api-raw-types';
import {CategoryPredictionResource} from '@/common/api/api-raw-types';

export class FreelancerProfileService {
    async retrieveCategoryPrediction(jobTitle: string): Promise<HttpServiceResponse<RawModel.CategoryPredictionResource[]>> {
        const url = urlService.buildUrl(context.registry.entries.categoryPredictions(), jobTitle);
        const [data, error] = await context.httpService.get<RawModel.CategoryPredictionResource[]>(url);
        if (error || !data) {
            return [null, error];
        }
        return [data, null];
    }

    async retrieveFamiliesAndCategories(): Promise<HttpServiceResponse<FamilyResult[]>> {
        const [data, error] = await context.httpService.get<RawModel.FamilyResource[]>(context.registry.entries.familiesAndCategories());
        if (error || !data) {
            return [null, error];
        }
        return [this.formatFamilies(data), null];
    }

    private formatFamilies(data: RawModel.FamilyResource[]): FamilyResult[] {
        return data.map((family) => ({
            name: family.label,
            family: family.familyId,
            categories: this.formatCategories(family.categories),
        }));
    }

    private formatCategories(data: RawModel.FreelancerCategoryResource[]): CategoryResult[] {
        return data.map((category) => ({
            name: category.label,
            category: category.categoryId,
        }));
    }
}
